module.exports = __webpack_public_path__ + "static/alhoon-7453ae1ebac5d24fade1d1aa8796c057.jpeg";